module.exports = __webpack_public_path__ + "static/media/skydancelogov2center_h.89169fca.png";